import React from 'react'
import HeroSection from './HeroSection'

export default () => (
  <HeroSection
    left={
      <>
        <p className="topic">emotional well-being</p>
        <h2>Practice gratitude</h2>
        <p className="description">
          Start and complete each day by journaling your gratitude to make
          happiness your way of being.
        </p>
      </>
    }
    right={
      <img
        className="screenshot-right"
        src="/images/app/app-screen-2@2x.png"
        alt="showing overall steps taken"
      />
    }
  />
)
